__turbopack_context__.v({
  "note": "_6_E86a_note",
  "panels": "_6_E86a_panels",
  "tools": "_6_E86a_tools",
});
